// extracted by mini-css-extract-plugin
export default {"main":"ResultText_main__Llf5t","text":"ResultText_text__xQcTu"};